<template>
    <div class="cardBody1" style="position: relative">
    <el-row>
      <el-col class="infoProducto" :span="24">
        <el-row>
          <el-col :xs="2" :sm="2" :md="1" :lg="1" :xl="1">
            <div :class="opened ? 'triangleDown' : 'triangleRight'" v-on:click="toggleOpen"></div>
          </el-col>
          <el-col :xs="2" :sm="2" :md="1" :lg="1" :xl="1">
            <div class='iconContainer' v-if="permitirEditar" @click="eliminarProducto"><i class="el-icon-delete"></i></div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="4" :lg="4" :xl="4">
            <div class="label NombreProducto">{{ producto.Clave }}</div>
          </el-col>
          <el-col v-if="!esDetalle" :xs="12" :sm="12" :md="7" :lg="7" :xl="7">
          <div class="label">{{ producto.Descripcion }}</div>
          </el-col>
          <!-- si es un detalle, muestro un input editable en descripción -->
          <div v-else>
            <div v-if="permitirEditar">
              <el-col :xs="11" :sm="11" :md="6" :lg="6" :xl="6">
                <span>
                  <el-input
                  ref="descripcion"
                  class="label"
                  type="text"
                  size="mini"
                  :placeholder="$t('PRESUPUESTO_descripcion_editar_placeholder')"
                  clearable
                  v-model="producto.Descripcion"
                  :disabled="!this.editarDescripcion"
                  :span="11"
                  @blur="finEditarDescripcion"
                  @focus="this.isTypingDescripcion= true"
                  ></el-input>
                </span>
              </el-col>
              <el-col :span="1">
                <div class='iconContainer' @click="editarDescripcionM"><i class="el-icon-edit"></i></div>
              </el-col>
            </div>
            <div v-else>
              <el-col :xs="12" :sm="12" :md="7" :lg="7" :xl="7">
                <span>
                  <el-input
                  ref="descripcion"
                  class="label"
                  type="text"
                  size="mini"
                  :placeholder="$t('PRESUPUESTO_descripcion_editar_placeholder')"
                  clearable
                  v-model="producto.Descripcion"
                  :disabled="!this.editarDescripcion"
                  :span="11"
                  @blur="finEditarDescripcion"
                  @focus="this.isTypingDescripcion= true"
                  ></el-input>
                </span>
              </el-col>
            </div>
          </div>

          <!-- vista para computadora -->
          <el-col class="hidden-sm-and-down" :md="4" :lg="4" :xl="4">
            <div class="selectCantidadProducto">
              <div v-if="esDetalle">
                <InputNumber
                  :Cantidad="producto.Cantidad"
                  :AdmiteDecimales="'N'"
                  :Minimo="'1'"
                  :Disabled="!permitirEditar"
                  v-model="cantidadAux"
                  @cambio="cambiarCantidadSeleccionada"/>
              </div>
              <div v-else>
                <InputNumber
                  :Cantidad="producto.Cantidad"
                  :AdmiteDecimales="producto.AdmiteDecimales"
                  :Minimo="producto.AdmiteDecimales=='N' ? '1' : '0.1'"
                  :Disabled="!permitirEditar"
                  v-model="cantidadAux"
                  @cambio="cambiarCantidadSeleccionada"/>
              </div>
            </div>
          </el-col>

          <div v-if="pantallaOrigen == 'PedidoADistribuidor' 
                || pantallaOrigen == 'PedidoSubagente'">
            <el-col class="hidden-sm-and-down" :md="1" :lg="1" :xl="1">
              <div class="unidadMedida">{{producto.UnidadMedida}}</div>
            </el-col>
          </div>

          <div v-else>
            <el-col class="hidden-sm-and-down" :md="1" :lg="1" :xl="1">
            <div class="unidadMedida">{{producto.UnidadMedida}}</div>
          </el-col>
            <el-col class="hidden-sm-and-down" :md="2" :lg="2" :xl="2">
              <div class="label labelSubTotal">{{$t('GENERAL_subtotal')}}:</div>
            </el-col>
            <el-col class="hidden-sm-and-down" :md="3" :lg="3" :xl="3">
              <div class="label precio">{{ decimalToString(subtotal) }}</div>
            </el-col>
              <el-col class="hidden-sm-and-down" :md="1" :lg="1" :xl="1">
                <div v-if="this.esDetalle == false">
                  <div v-if="this.producto.Moneda != ''" class="referencia">(+)</div>
                </div>
            </el-col>
          </div>

        </el-row>
        
        <!-- vista para celular -->
        <el-row class="hidden-md-and-up">
          <el-col :span="8">
            <div class="selectCantidadProducto">
              <div v-if="esDetalle">
                <InputNumber
                  :Cantidad="producto.Cantidad"
                  :AdmiteDecimales="'N'"
                  :Minimo="'1'"
                  :Disabled="!permitirEditar"
                  v-model="producto.Cantidad"
                  @cambio="cambiarCantidadSeleccionada"/>
              </div>
              <div v-else>
                <InputNumber
                  :Cantidad="producto.Cantidad"
                  :AdmiteDecimales="producto.AdmiteDecimales"
                  :Minimo="producto.AdmiteDecimales=='N' ? '1' : '0.1'"
                  :Disabled="!permitirEditar"
                  v-model="producto.Cantidad"
                  @cambio="cambiarCantidadSeleccionada"/>
              </div>
            </div>
          </el-col>
          

          <div v-if="pantallaOrigen == 'PedidoADistribuidor' 
                || pantallaOrigen == 'PedidoSubagente'">
            <el-col class="unidadMedida" :span="4">
            <div >{{producto.UnidadMedida}}</div>
            </el-col>
          </div>

          <div v-else>
            <el-col class="unidadMedida" :span="4">
            <div >{{producto.UnidadMedida}}</div>
            </el-col>
            <el-col :span="4">
              <div class="label precio">{{$t('GENERAL_subtotal')}}:</div>
            </el-col>
            <el-col :span="6">
              <div class="label precio">{{ decimalToString(subtotal) }}</div>
            </el-col>
            <div v-if="this.esDetalle==false">
              <el-col :span="3">
                <div v-if="this.producto.Moneda != ''" class="referencia">(+)</div>
              </el-col>
            </div>
          </div>

        </el-row>

        <transition name="fade">
            <div v-show="opened">

              <!-- Si es Vista de Pedidos Subagentes o distribuidor -->
              <el-row v-if="pantallaOrigen == 'PedidoADistribuidor' 
                      || pantallaOrigen == 'PedidoSubagente'">

                <el-col :xs="2" :sm="2" :md="1" :lg="1" :xl="1">
                  <div class="label">{{$t('PEDIDO_iva')}}: </div>
                </el-col>
                <el-col :xs="3" :sm="3" :md="2" :lg="3" :xl="4">
                  <div class="label">{{ this.producto.IVA }}%</div>
                </el-col>
                 <el-col :xs="6" :sm="5" :md="3" :lg="3" :xl="3" style="margin-left: 2.5%;">
                <div class="contenerdorPromo" v-if="this.producto.Promocion > 0" >
                  <div class="contendorLinea">
                    <el-col :xs="6" :sm="5" :md="3" :lg="3" :xl="3">
                    <div class="label">{{$t('PEDIDO_bonificacion')}}: </div>
                  </el-col>
                  <el-col :xs="2" :sm="2" :md="3" :lg="2" :xl="2">
                    <div class="label">{{ this.producto.BonificacionPorcentaje }}%</div>
                  </el-col>
                  </div>
                  <div class="contendorLinea">
                    <el-col :xs="6" :sm="5" :md="3" :lg="3" :xl="3">
                    <div class="label">{{$t('PEDIDO_promocion')}}: </div>
                  </el-col>
                  <el-col :xs="2" :sm="2" :md="3" :lg="2" :xl="2">
                    <div class="label">{{ this.producto.Promocion }}%</div>
                  </el-col>
                  </div>
                </div>
                </el-col>
                  
              </el-row>

              <!-- Si es vista pedido o presupuesto -->
              <el-row v-else>
                <div >
                  <el-col :xs="5" :sm="6" :md="4" :lg="4" :xl="3">
                  <div class="label">{{$t('PRODUCTO_precio_unitario')}}: </div>
                </el-col>
                <el-col v-if="!esDetalle" :xs="5" :sm="4" :md="4" :lg="4" :xl="4">
                  <div  class="label"> {{ decimalToString(producto.Precio) }}</div>
                </el-col>
                <div v-else>
                  <div v-if="permitirEditar">
                    <el-col :xs="2" :sm="2" :md="3" :lg="3" :xl="3">
                      <span>
                        <el-input
                        ref="precio"
                        class="label"
                        type="text"
                        size="mini"
                        :placeholder="$t('PRESUPUESTO_precio_editar_placeholder')"
                        clearable
                        v-model="producto.Precio"
                        :disabled="!this.editarPrecio"
                        :span="11"
                        @blur="finEditarPrecio"
                        @focus="this.isTypingPrecio= true"
                        ></el-input>
                      </span>
                    </el-col>
                    <el-col :span="1">
                      <div class='iconContainer' @click="editarPrecioM"><i class="el-icon-edit"></i></div>
                    </el-col>
                  </div>
                  <div v-else>
                    <el-col :xs="3" :sm="3" :md="4" :lg="4" :xl="4">
                      <span>
                        <el-input
                        ref="precio"
                        class="label"
                        type="text"
                        size="mini"
                        :placeholder="$t('PRESUPUESTO_precio_editar_placeholder')"
                        clearable
                        v-model="producto.Precio"
                        :disabled="!this.editarPrecio"
                        :span="11"
                        @blur="finEditarPrecio"
                        @focus="this.isTypingPrecio= true"
                        ></el-input>
                      </span>
                    </el-col>
                  </div>
                  
                </div>
                
                </div>
                

                <el-col :xs="2" :sm="2" :md="1" :lg="1" :xl="1">
                  <div class="label">{{$t('PEDIDO_iva')}}: </div>
                </el-col>
                <el-col :xs="3" :sm="3" :md="2" :lg="3" :xl="4">
                  <div class="label">{{ this.producto.IVA }}%</div>
                </el-col>
                  <el-col :xs="4" :sm="4" :md="3" :lg="3" :xl="2" v-if="!permitirEditar">
                    <div class="label">{{$t('PEDIDO_despachado')}}:</div>
                  </el-col>
                  <el-col :xs="2" :sm="2" :md="3" :lg="1" :xl="4" v-if="!permitirEditar">
                    <div class="label">{{ this.producto.CantidadDespachada }}</div>
                  </el-col>
                  <el-col :xs="6" :sm="5" :md="3" :lg="3" :xl="3" style="margin-left: 2.5%;">
                  <div class="contenerdorPromo">
                    <div class="contendorLinea">
                      <el-col :xs="6" :sm="5" :md="3" :lg="3" :xl="3">
                    <div class="label">{{$t('PEDIDO_bonificacion')}}: </div>
                  </el-col>
                  <el-col :xs="2" :sm="2" :md="3" :lg="2" :xl="2">
                    <div class="label">{{ this.producto.BonificacionPorcentaje }}%</div>
                  </el-col>
                    </div>
                    <div v-if="pantallaOrigen != 'Presupuesto' && pantallaOrigen != 'PresupuestoConfirmar' && this.producto.Promocion > 0" class="contendorLinea">
                      <el-col :xs="6" :sm="5" :md="3" :lg="3" :xl="3">
                    <div class="label">{{$t('PEDIDO_promocion')}}: </div>
                  </el-col>
                  <el-col :xs="2" :sm="2" :md="3" :lg="2" :xl="2">
                    <div class="label">{{ this.producto.Promocion }}%</div>
                  </el-col>
                    </div>
                  </div>
                  </el-col>
                  <!-- <div class="promoPresupuesto" v-if="this.producto.Promocion > 0">
                    <el-col v-if="!esDetalle && pantallaOrigen == 'Presupuesto' " :xs="6" :sm="5" :md="3" :lg="3" :xl="3">
                    <div class="label">{{$t('PEDIDO_promocion')}}: </div>
                  </el-col>
                  <el-col v-if="!esDetalle && pantallaOrigen == 'Presupuesto'" :xs="2" :sm="2" :md="3" :lg="1" :xl="2">
                    <div class="label">{{ this.producto.Promocion }}%</div>
                  </el-col>

                   <el-col v-if="!esDetalle && pantallaOrigen == 'PresupuestoConfirmar'" :xs="6" :sm="5" :md="3" :lg="3" :xl="3">
                    <div class="label">{{$t('PEDIDO_promocion')}}: </div>
                  </el-col>
                  <el-col v-if="!esDetalle && pantallaOrigen == 'PresupuestoConfirmar'" :xs="2" :sm="2" :md="3" :lg="1" :xl="2">
                    <div class="label">{{ this.producto.Promocion }}%</div>
                  </el-col>
                  </div> -->
                  
              </el-row>

              <el-row class="manoobra">
                
                <!-- Mano de Obra Nuevo Presupuesto -->

                <el-col :span="16">
                  <div class="promoPresupuesto">
                    <el-col v-if="!esDetalle && pantallaOrigen == 'Presupuesto'" :span="6">
                  <div class="label">{{$t('PRESUPUESTO_mano_obra')}}</div>
                </el-col>
                <el-col v-if="!esDetalle && pantallaOrigen == 'Presupuesto'" :span="5">
                  <div  class="label"> {{ decimalToString(producto.ManoObra) }}</div>
                </el-col>
                <el-col v-if="!esDetalle && pantallaOrigen == 'Presupuesto'" :span="5">
                  <el-checkbox v-model="producto.ManoObraChecked" :disabled="!this.permitirEditar" @change="changeManoObraChecked"></el-checkbox>
                </el-col>

                <!-- Mano de Obra Confirmar Presupuesto -->
                <el-col v-if="!esDetalle && pantallaOrigen == 'PresupuestoConfirmar'" :span="5">
                  <div class="label">{{$t('PRESUPUESTO_mano_obra')}}</div>
                </el-col>
                <el-col v-if="!esDetalle && pantallaOrigen == 'PresupuestoConfirmar'" :span="5">
                  <div  class="label"> {{ decimalToString(producto.ManoObra) }}</div>
                </el-col>
                  </div>
                  
                </el-col>

                <el-col :span="6">
                  <div class="promoPresupuesto" v-if="this.producto.Promocion > 0">
                    <el-col v-if="!esDetalle && pantallaOrigen == 'Presupuesto' " >
                    <div class="label">{{$t('PEDIDO_promocion')}}: </div>
                  </el-col>
                  <el-col v-if="!esDetalle && pantallaOrigen == 'Presupuesto'" >
                    <div class="label">{{ this.producto.Promocion }}%</div>
                  </el-col>

                   <el-col v-if="!esDetalle && pantallaOrigen == 'PresupuestoConfirmar'" >
                    <div class="label">{{$t('PEDIDO_promocion')}}: </div>
                  </el-col>
                  <el-col v-if="!esDetalle && pantallaOrigen == 'PresupuestoConfirmar'" >
                    <div class="label">{{ this.producto.Promocion }}%</div>
                  </el-col>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="23">
                  <span class="nota-tecnica">
                    <el-input
                    ref="nota"
                    class="label"
                    type="text"
                    size="mini"
                    :placeholder="$t('PRODUCTO_nota_tecnica')"
                    clearable
                    v-model="producto.NotaTecnica"
                    :disabled="!this.editarNota"
                    @blur="finEditarNotaTecnica"
                    @focus="this.isTyping= true"
                    ></el-input>
                </span>
                </el-col>
                <el-col :span="1">
                  <div class='iconContainer' v-if="permitirEditar" @click="editarNotaTecnica"><i class="el-icon-edit"></i></div>
                </el-col>
              </el-row>
            </div>
        </transition>
      </el-col>
    </el-row>
    <transition name="fade">
      <!-- se agrego al if del badge que no lo muestre si la vista pertenece a los dos nuevos pedidos
           luego se podria optimizar-->
      <div v-if="!opened && !permitirEditar && !esPresupuesto && 
      (pantallaOrigen != 'PedidoADistribuidor' && pantallaOrigen != 'PedidoSubagente')" 
      class="badge">
        <el-badge :value="$t('PEDIDO_despachado') + ': ' + this.producto.CantidadDespachada" type="primary">
        </el-badge>
      </div>
    </transition>
    
    </div>

</template>

<script>
  import { decimalToString } from '../Helpers/commonFunctions'
  import InputNumber from "../InputNumber/InputNumber";

  export default {
    name: "ProductoSeleccionadoCard",
    props: {
      producto: Object,
      permitirEditar: Boolean,
      esExento: Boolean,
      esDetalle: Boolean,
      index: undefined,
      pantallaOrigen: String,
    },
    components: { InputNumber },
    data() {
      return {
        defaultImage: './images/logo.png',
        //POR DEFAULT TOMA LA CantidadSeleccionada DEL PRODUCTO SELECCIONADO PARA QUE CALCULE EL SUBTOTAL DEL PEDIDO INICIAL
        diferenciaCantidadSeleccionada: this.producto.Cantidad,
        editarNota: false,
        isTyping: false,
        editarDescripcion: false,
        isTypingDescripcion: false,
        editarPrecio: false,
        isTypingPrecio: false,
        opened: false,
        sinEditar: false,
        cantidadAux:this.producto.Cantidad,
        valorViejoPrecio: 0,
        valorNuevoPrecio: this.producto.Precio,
        diferenciaPrecioSeleccionado: this.producto.Precio,
        cambioPrecio: false,
        focus: false,

        PantallaOrigen: this.pantallaOrigen,
      }
    },

    methods:
    {
      decimalToString: decimalToString,

      cambiarCantidadSeleccionada(valorNuevo, valorViejol){
        //CALCULA LA CantidadSeleccionada QUE TIENE QUE SUMA O RESTAR EN EL PEDIDO
        if(valorNuevo[valorNuevo.length - 1] !='.'){
          let valorViejo = this.producto.Cantidad;
          this.producto.Cantidad = valorNuevo;

          this.diferenciaCantidadSeleccionada = this.producto.AdmiteDecimales != 'N'?(valorNuevo - valorViejo).toFixed(1):valorNuevo - valorViejo;
          this.$emit('cambiarEditar', this.sinEditar);
          this.$emit('datosPedido',this.datosProducto);
        }
      },
      async editarNotaTecnica() {
        await this.changeEditarNota();
        //this.$nextTick(() =>this.$refs.nota.f$el.children[0].focus());
        this.$refs.nota.focus();
      },
      async changeEditarNota(){
        this.editarNota = !this.editarNota;

      },
      toggleOpen() {
        this.opened = !this.opened
      },
      eliminarProducto() {
        this.diferenciaCantidadSeleccionada = 0 - this.producto.Cantidad; 

        this.$emit('eliminarProducto',this.producto,this.datosProducto);
      },
      finEditarNotaTecnica() {
        this.editarNota = false;
        this.isTyping = false;
        //Aviso que se edito
        this.$emit('cambiarEditar', this.sinEditar);
      },
      async editarDescripcionM() {
        await this.changeEditarDescripcion();
        //this.$nextTick(() =>this.$refs.nota.$el.children[0].focus());
        this.$refs.descripcion.focus();
      },
      async changeEditarDescripcion(){
        this.editarDescripcion = !this.editarDescripcion;
      },
      finEditarDescripcion() {
        this.editarDescripcion = false;
        this.isTypingDescripcion = false;
        //Aviso que se edito
        this.$emit('cambiarEditar', this.sinEditar);

      },
      async editarPrecioM() {
        this.valorViejoPrecio = this.valorNuevoPrecio;
        await this.changeEditarPrecio();
        //this.$nextTick(() =>this.$refs.nota.$el.children[0].focus());
        this.$refs.precio.focus();
      },
      async changeEditarPrecio(){
        this.editarPrecio = !this.editarPrecio;
      },
      finEditarPrecio() {
        this.$emit('modificarSubtotalDetalle', this.index, this.subtotal);
        this.valorNuevoPrecio = this.producto.Precio;
        this.editarPrecio = false;
        this.isTypingPrecio = false;
        this.diferenciaPrecioSeleccionado = this.valorNuevoPrecio - this.valorViejoPrecio;
        this.cambioPrecio = true;
        this.$emit('datosPedido', this.datosProducto);
        this.cambioPrecio = false;
        //Aviso que se edito
        this.$emit('cambiarEditar', this.sinEditar);
      },
      changeManoObraChecked(){
        let valorViejo = !this.datosProducto.manoObraChecked;
        var oldSubTotal = 0;
        if(valorViejo == true){
          oldSubTotal = this.producto.Cantidad * (this.producto.Precio + this.producto.ManoObra);
        }else{
          oldSubTotal = this.producto.Cantidad *this.producto.Precio;
        }
        
        this.$emit('cambiarEditar', this.sinEditar);
        this.$emit('datosPedidoManoObra', this.datosProducto, oldSubTotal);
        
      }
    },
    mounted: function(){
      if(this.permitirEditar) {
        this.$emit('datosPedido', this.datosProducto);
        //this.$emit('datosPresupuesto', this.datosProducto);
      }

      if(this.esExento) this.producto.IVA = 0;
    },

    computed:{
      datosProducto: function(){
          return {
          Nombre: this.producto.Nombre == undefined? this.producto.Clave:this.producto.Nombre,
          Clave:this.producto.Clave,
          Cantidad: this.esDetalle && this.cambioPrecio ? this.producto.Cantidad : this.diferenciaCantidadSeleccionada,
          precioUnitario: this.esDetalle && this.cambioPrecio ? this.diferenciaPrecioSeleccionado : this.producto.Precio,
          IVA: this.producto.IVA,
          //BonificacionImporte: this.producto.BonificacionImporte == undefined? (this.producto.Precio*this.diferenciaCantidadSeleccionada) * (this.producto.BonificacionPorcentaje/100) : this.producto.BonificacionImporte,
          BonificacionImporte: this.producto.BonificacionImporte == undefined?0: this.producto.BonificacionImporte,
          BonificacionPorcentaje: this.producto.BonificacionPorcentaje,
          Promocion: this.producto.Promocion,
          UnidadMedida: this.producto.UnidadMedida,
          AdmiteDecimales: this.producto.AdmiteDecimales,
          ManoObra: this.producto.ManoObra,
          manoObraChecked: this.producto.ManoObraChecked,
          SubTotal: this.producto.ManoObraChecked && this.pantallaOrigen == "Presupuesto" ? 
                this.producto.Cantidad * (this.producto.Precio + this.producto.ManoObra) : this.producto.Cantidad *this.producto.Precio,
          }
        },
        precioDetalle: function() {
          return {
            //Diferencia: this.valorNuevoPrecio-this.valorViejoPrecio
          }
        },
        subtotal: function(){
         //CALCULA EL SUBTOTAL DEL PRODUCTO SELECCIONADO
        if((this.pantallaOrigen == "Presupuesto" || this.pantallaOrigen == "PresupuestoConfirmar") && this.producto.ManoObraChecked){
          this.producto.subtotal = this.producto.Cantidad * (this.producto.Precio + this.producto.ManoObra);
          return this.producto.Cantidad * (this.producto.Precio + this.producto.ManoObra);
        }else{
          this.producto.subtotal = this.producto.Cantidad * this.producto.Precio;
          return this.producto.Cantidad * this.producto.Precio;
        }
        
        },
        esPresupuesto()
        {
          return this.$router.history.current.path.includes('presupuestos')
        }
    },
}
</script>

<style scoped>
.manoobra {
  display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    gap: 12px;
    margin-left: 3px !important;
}
.promoPresupuesto {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;

}
.contenerdorPromo {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-start;
  width: 110px;
  max-width: 110px;
}
.contendorLinea {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  width: 100%;
}
.unidadMedida {
  padding-top: 5px;
  margin-left: 1px;
  margin-right: 2px;
}
.badge 
{
  position: absolute; 
  bottom: 0; 
  right: 0;
  margin-right: 5px;
}
.labelSubTotal{
  margin-left: 4px;
  margin-top: 5px;
}
.referencia{
  margin-top: 4px;
  text-align: right;
  opacity: 0.5;
}
.triangleRight,
.triangleDown {
  width: 0;
  height: 0;
  border-style: solid;
  cursor: pointer;
}
.triangleRight {
  border-width: 8px 0 8px 13.9px;
  border-color: transparent transparent transparent var(--main-color);
}
.triangleDown {
  border-width: 13.9px 8px 0 8px;
  border-color: var(--main-color) transparent transparent transparent;
}
.label.precio{
  text-align: left;
}
.label.NombreProducto{
  color: var(--main-color);
}
.content {
  padding: 17px;
  padding-bottom: 0;
  max-width: 400px;
}
.label {
  text-align: left;
  margin-bottom: 4px;
  font-size: 14px;
}
.el-card {
  height: 100%;
  width: 100% !important;
}
.cardBody1 {
    width: 100%;
    padding: 10px 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
.number{
  text-align: center;
  width: 15px;
  height: 20px;
  border: 1px solid var(--main-color);
}
.boton{
  cursor: pointer;
  width: 30px;
  border: 1px solid var(--main-color);
  background-color: var(--main-color);
  border-radius: 1px;
  text-align: center;
}
.infoProducto .el-row{
  margin-left: 15px;
}

.iconoProd{
  color: #ffffff;
  font-weight: bold;
}
.el-row{
  margin-bottom: 5px;
  align-content: center;
}
.precio{
  margin-right: 15px;
  margin-left: 5px;
  margin-top: 5px;
}
.iconContainer{
  cursor: pointer;
}



</style>

<style>
/* .selectCantidadProducto .el-input-number--mini{
    width: 7em;
} */

.el-input-number__increase, .el-input-number__decrease{
  background: var(--main-color) ;
  color: white;
  width: 100%;

}


 .el-input.is-disabled .el-input__inner {
  border: 0;
  outline: 0;
  width: 100%;
  background-color: #b4c3c729;
  border-bottom: 1px solid #DCDFE6;
  color: rgba(0, 0, 0, 0.849);
}

@media (max-width: 600px) {
  /* .selectCantidadProducto .el-input-number--mini{
    width: 6em;
  } */
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>
